import { Type } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';

export enum HeaderThemeEnum {
    DEFAULT = "default",
    DARK = "dark",
    CUSTOM = "custom"
}

export interface TopContactsConfig{
    contactNumber?:string;
}

export interface TopMessageConfig {
    message?:string
}

export interface TopSocialContactsConfig {
    showAboutUsLink:boolean;
    showBlogLink:boolean;
    showFaceBookLink:boolean;
    showTwitterLink:boolean;
    aboutUsLink?:string;
    blogLink?:string;
    faceBookLink?:string;
    twitterLink?:string;
}

export interface TopHeaderConfig{
    showTopContacts:boolean;
    showTopMessage:boolean;
    showTopSocialContacts:boolean;
    topContactsConfig?:TopContactsConfig;
    topMessageConfig?:TopMessageConfig;
    topSocialContactsConfig?:TopSocialContactsConfig;
    custom?:boolean;
    background?:string;
    mainDark?:boolean;
    themeEnum?:HeaderThemeEnum;
    color?:string;
}

export interface LogoNavConfig {
    logoUrl:string
    storeName:any;
    imgSrc?:any;
    showStoreName?:boolean;
}

export interface MainHeaderConfig{
    containsMainNav:boolean;
    mainDark:boolean;
    background?:string;
    logoNavConfig?:LogoNavConfig;
    menuItems?:NbMenuItem[];
    custom?:boolean;
    themeEnum?:HeaderThemeEnum;
    color?:string;
}

export interface CustomConfig{
    background?:string;
}

export interface BottomHeaderConfig{
    mainNav?:any;
    menuItems?:NbMenuItem[];
    custom?:boolean;
    background?:string;
    mainDark?:boolean;
    themeEnum?:HeaderThemeEnum ;
    color?:string;   
}

export interface HeaderConfig {
    sectionId:string;
    topHeader:boolean;
    mainHeader:boolean;
    bottomHeader:boolean;
    topHeaderConfig?:TopHeaderConfig;
    mainHeaderConfig?:MainHeaderConfig;
    bottomHeaderConfig?:BottomHeaderConfig;
    headerTheme?:HeaderThemeEnum;
    mainNavLocation?:string;
    userNavLocation?:string;
    mainMenuConfig?:MenuConfig;
    userMenuConfig?:MenuConfig;
}

export interface MenuConfig{
    levels?:number;
    asActions?:boolean;
    iconsOnly?:boolean;
    location?:MenuLocation;
    menuItems:NbMenuItem[];
    menuTag?:string;
}

export enum MenuLocation{
    TOP = "top",
    MAIN = "main",
    BOTTOM = "bottom"
}

export class KwikstoreHeader {
    topHeader:HeaderItemComponent;
    mainHeader:HeaderItemComponent;
    bottomHeader:HeaderItemComponent;

    constructor(options:{
        topHeader?:HeaderItemComponent,
        mainHeader?:HeaderItemComponent,
        bottomHeader?:HeaderItemComponent
    }={}){
        this.topHeader = options.topHeader;
        this.mainHeader = options.mainHeader;
        this.bottomHeader = options.bottomHeader
    }
}

export interface HeaderItemComponent{
    component:Type<any>
    leftContent:Type<any>
    centerContent:Type<any>
    rightContent:Type<any>
}